import { render } from "./FilePreviewComponent.vue?vue&type=template&id=1f6c93a4"
import script from "./FilePreviewComponent.vue?vue&type=script&lang=js"
export * from "./FilePreviewComponent.vue?vue&type=script&lang=js"

import "./FilePreviewComponent.vue?vue&type=style&index=0&id=1f6c93a4&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__